import { css } from 'styled-components';
import { rem } from 'polished';

export const ThumbStyles = css`
  border: ${rem(1)} solid ${({ theme }) => theme.color.gray93};
  border-radius: ${({ theme }) => rem(theme.borderRadius.default)};
`;
